import {getDate} from '../_metronic/helpers'
import {setupAxios} from '../app/modules/auth'
import {API_BASE_URL} from '../utils/contants'
import {api} from './APIMiddlewares'
import API from './APIUrl'
import axios from 'axios'

export async function getAttendanceByDate(date: string) {
  const { token, tenantId } = setupAxios()

  return api.get(
    `/${API.ATTENDENCE}/by-date?date=${date}`,
    token,
    tenantId,
    false
  )
}

// ===== TODAY ATTENDANCE SUMMARY (DASHBOARD CARDS) =====
export async function getTodayAttendanceSummary() {
  const {token, tenantId} = setupAxios()

  return api.get(
    `/attendances/today-summary`,
    token,
    tenantId,
    false
  )
}
// ===== NEW FUNCTION: TODAY OR DATE RANGE ATTENDANCE SUMMARY =====
export async function getAttendanceSummary(params: {
  startDate: string
  endDate: string
}): Promise<{
  statusCode: number
  data: {
    attendanceRecords: any[]
    counts: {
      present: number
      absent: number
      late: number
      onLeave: number
      weeklyOff: number
      earlyLeave?: number
      halfDay?: number
      total: number
    }
    pagination: any
  }
}> {
  const { token, tenantId } = setupAxios()

  const queryParams = new URLSearchParams()
  queryParams.append('startDate', params.startDate)
  queryParams.append('endDate', params.endDate)

  const res = await api.get(
    `/attendances/summary?${queryParams.toString()}`,
    token,
    tenantId,
    false
  )

  return res
}


// ===== DASHBOARD MONTHLY SUMMARY (ATTENDANCE + LEAVE) =====
export async function getDashboardSummary(params: {
  departmentId?: string
  employmentType?: string
  month: string // "2026-01"
}): Promise<any> {
  const { token, tenantId } = setupAxios()

  const queryParams = new URLSearchParams()
  Object.entries(params).forEach(([key, value]) => {
    if (value) {
      queryParams.append(key, value)
    }
  })

  return await api.get(
    `/attendances/dashboard-summary?${queryParams.toString()}`,
    token,
    tenantId,
    false
  )
}


  // ===============================
  // ATTENDANCE EDIT REQUEST TYPES
  // ===============================

  export interface CreateAttendanceEditRequest {
    attendanceDate: string
    requestedInTime?: string
    requestedOutTime?: string
    reason: string
  }

  export type AttendanceEditStatus = 'PENDING' | 'APPROVED' | 'REJECTED'

  export interface AttendanceEditRequest {
    id: number
    employeeCode: string
    attendanceDate: string
    oldInTime?: string
    oldOutTime?: string
    requestedInTime?: string
    requestedOutTime?: string
    reason: string
    status: AttendanceEditStatus
    requestedAt: string
    approvedBy?: string
    approvedAt?: string
  }

  // ===============================
  // EMPLOYEE – ATTENDANCE EDIT REQUEST
  // ===============================

  export async function createAttendanceEditRequest(
    data: CreateAttendanceEditRequest
  ): Promise<any> {
    const {token, tenantId} = setupAxios()

    return await api.post(
      `/${API.ATTENDENCE}/edit-requests`,
      token,
      tenantId,
      {
        body: JSON.stringify(data),
      },
      false
    )
  }

  export async function getMyAttendanceEditRequests(): Promise<any> {
    const {token, tenantId} = setupAxios()

    return await api.get(
      `/${API.ATTENDENCE}/edit-requests/my`,
      token,
      tenantId,
      false
    )
  }
  // ===============================
  // HR / ADMIN – ATTENDANCE EDIT REQUEST
  // ===============================

  export async function getAttendanceEditRequests(params?: {
    status?: AttendanceEditStatus
    employeeCode?: string
    startDate?: string
    endDate?: string
  }): Promise<any> {
    const {token, tenantId} = setupAxios()

    const queryParams = new URLSearchParams()
    if (params) {
      Object.entries(params).forEach(([key, value]) => {
        if (value) queryParams.append(key, value)
      })
    }

    return await api.get(
      `/${API.ATTENDENCE}/edit-requests?${queryParams.toString()}`,
      token,
      tenantId,
      false
    )
  }

  export async function approveAttendanceEditRequest(
    requestId: number
  ): Promise<any> {
    const {token, tenantId} = setupAxios()

    return await api.post(
      `/${API.ATTENDENCE}/edit-requests/${requestId}/approve`,
      token,
      tenantId,
      {body: JSON.stringify({})},
      false
    )
  }

  export async function rejectAttendanceEditRequest(
    requestId: number,
    rejectionReason: string
  ): Promise<any> {
    const {token, tenantId} = setupAxios()

    return await api.post(
      `/${API.ATTENDENCE}/edit-requests/${requestId}/reject`,
      token,
      tenantId,
      {
        body: JSON.stringify({rejectionReason}),
      },
      false
    )
  }





  // Types for the new CRUD operations
  export interface CreateAttendanceRequest {
    employeeCode: string
    date: string
    shift?: string
    inTime?: string
    outTime?: string
    duration?: string
    lateBy?: string
    earlyBy?: string
    status?: string
    punchRecords?: string
    overtime?: string
  }

  export interface UpdateAttendanceRequest {
    shift?: string
    inTime?: string
    outTime?: string
    duration?: string
    lateBy?: string
    earlyBy?: string
    status?: string
    punchRecords?: string
    overtime?: string
  }

  export interface AttendanceRecord {
    id: string
    employeeCode: string
    employeeName?: string
    user?: {
      firstName?: string
      lastName?: string
    }
    date: string
    shift: string
    inTime?: string
    outTime?: string
    duration?: string
    lateBy?: string
    earlyBy?: string
    status: string
    punchRecords?: string
    overtime?: string
    isWeekOffDay?: boolean  //Week-Off

  }

  export interface PayrollSummary {
    employeeCode: string
    totalDays: number
    presentDays: number
    absentDays: number
    lateDays: number
    overtimeHours: number
    totalWorkingHours: number
  }

  // ===== NEW CRUD OPERATIONS =====

  // Create a single attendance record
  export async function createAttendanceRecord(attendanceData: CreateAttendanceRequest): Promise<any> {
    const {token, tenantId} = setupAxios()
    
    return await api
      .post(
        `/${API.ATTENDENCE}/records`,
        token,
        tenantId,
        {
          body: JSON.stringify(attendanceData),
        },
        false
      )
      .then((res) => res)
  }

  // Get a single attendance record by employee code and date
  export async function getAttendanceRecord(employeeCode: string, date: string): Promise<any> {
    const {token, tenantId} = setupAxios()
    
    return await api
      .get(
        `/${API.ATTENDENCE}/${employeeCode}/${date}`,
        token,
        tenantId,
        false
      )
      .then((res) => res)
  }

  // Update an attendance record
  export async function updateAttendanceRecord(
    employeeCode: string,
    date: string,
    updateData: UpdateAttendanceRequest
  ): Promise<any> {
    const {token, tenantId} = setupAxios()
    
    return await api
      .put(
        `/${API.ATTENDENCE}/${employeeCode}/${date}`,
        token,
        tenantId,
        {
          body: JSON.stringify(updateData),
        },
        false
      )
      .then((res) => res)
  }

  // Partially update an attendance record
  export async function patchAttendanceRecord(
    employeeCode: string,
    date: string,
    updateData: Partial<UpdateAttendanceRequest>
  ): Promise<any> {
    const {token, tenantId} = setupAxios()
    
    return await api
      .patch(
        `/${API.ATTENDENCE}/${employeeCode}/${date}`,
        token,
        tenantId,
        {
          body: JSON.stringify(updateData),
        },
        false
      )
      .then((res) => res)
  }

  // Delete an attendance record
  export async function deleteAttendanceRecord(employeeCode: string, date: string): Promise<any> {
    const {token, tenantId} = setupAxios()
    
    return await api
      .delete(
        `/${API.ATTENDENCE}/${employeeCode}/${date}`,
        token,
        tenantId,
        false
      )
      .then((res) => res)
  }

  // Get attendance records with advanced filtering
  export async function getAttendanceRecords(params: {
    page?: number
    limit?: number
    startDate?: string
    endDate?: string
    userId?: string
    preset?: string
    search?: string
    sortBy?: string
    sort?: 'asc' | 'desc'
    status?: string 
  }): Promise<any> {
    const {token, tenantId} = setupAxios()
    
    const queryParams = new URLSearchParams()
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        queryParams.append(key, value.toString())
      }
    })
    
    return await api
      .get(
        `/${API.ATTENDENCE}?${queryParams.toString()}`,
        token,
        tenantId,
        false
      )
      .then((res) => res)
  }

  // Get attendance summary for payroll processing
  export async function getAttendanceForPayroll(params: {
    startDate?: string
    endDate?: string
    userId?: string
  }): Promise<any> {
    const {token, tenantId} = setupAxios()
    
    const queryParams = new URLSearchParams()
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        queryParams.append(key, value.toString())
      }
    })
    
    return await api
      .get(
        `/${API.ATTENDENCE}/payroll?${queryParams.toString()}`,
        token,
        tenantId,
        false
      )
      .then((res) => res)
  }

  // Export attendance records to Excel
  export async function exportAttendanceRecords(params: {
    page?: number
    limit?: number
    startDate?: string
    endDate?: string
    userId?: string
    preset?: string
    search?: string
    sortBy?: string
    sort?: 'asc' | 'desc'
    targetUserId?: string
    status?: string 
  }): Promise<Blob> {
    const {token, tenantId} = setupAxios()
    
    const queryParams = new URLSearchParams()
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        queryParams.append(key, value.toString())
      }
    })
    
    const response = await fetch(
      `${API_BASE_URL}/${API.ATTENDENCE}/export?${queryParams.toString()}`,
      {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'X-Tenant-Id': `${tenantId}`,
        },
      }
    )
    
    if (!response.ok) {
      const errorData = await response.json()
      throw new Error(errorData.message || 'Failed to export attendance records')
    }
    
    return await response.blob()
  }

  // ===== EXISTING FUNCTIONS (PRESERVED) =====

  export async function getPendingRequests(currentUser) {
    const {token, tenantId} = setupAxios()
    const res = await fetch(API_BASE_URL + `/attendence/early-checkout/pending/${currentUser.id}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        'X-Tenant-Id': `${tenantId}`,
      },
    })
    return await res.json()
  }

  export async function handleAttendancesApproves(id, currentUser) {
    const {token, tenantId} = setupAxios()
    return await api
      .patch(
        `/attendence/update`,
        token,
        tenantId,
        {
          body: JSON.stringify({
            remark: 'accept',
            id: id,
            actionBy: {id: currentUser?.id},
          }),
        },
        false
      )
      .then((res) => res)
  }
  export async function getAttendanceApplication(
    id: string,
    page: string,
    inputField: {
      startDate: string
      endDate: string
      status: string
      user: string
      reason: string
    },
    take: number = 10
  ) {
    const {token, tenantId} = setupAxios()
    return await api
      .post(
        `/attendence-application?page=${page}&take=${take}`,
        token,
        tenantId,
        {
          body: JSON.stringify({
            id: id ?? null,
            status: inputField?.status,
            filterUserId: !inputField.user ? null : inputField.user,
            startDate: inputField.startDate ? inputField.startDate + 'T00:00:00' : null,
            endDate: inputField.endDate ? inputField.endDate + 'T23:59:59' : null, // Ensure endDate is null if empty
          }),
        },
        false
      )
      .then((res) => res)
  }
  export async function handleAttendancessApproves(id, currentUser) {
    const {token, tenantId} = setupAxios()
    return await api
      .patch(
        `/attendence/update`,
        token,
        tenantId,
        {
          body: JSON.stringify({
            remark: 'accept',
            id: id,
            actionBy: {id: currentUser?.id},
          }),
        },
        false
      )
      .then((res) => res)
  }
  export async function handleForwardToHRs(
    inputField: {
      reason: string
    },
    id,
    currentUser
  ) {
    const {token, tenantId} = setupAxios()
    return await api
      .patch(
        `/attendence/update`,
        token,
        tenantId,
        {
          body: JSON.stringify({
            remark: 'review',
            reason: !inputField.reason ? null : inputField.reason || null,
            id: id,
            actor: 'Reporting Manager',
            actionBy: {id: currentUser?.id},
          }),
        },
        false
      )
      .then((res) => res)
  }
  export async function handleAttendanceRejects(
    inputField: {
      reason: string
    },
    idForReason: string,
    currentUser
  ) {
    const {token, tenantId} = setupAxios()
    return await api
      .patch(
        `/attendence/update`,
        token,
        tenantId,
        {
          body: JSON.stringify({
            remark: 'reject',
            reason: inputField.reason || null,
            id: idForReason,
            actor: 'HR Executive',
            actionBy: {id: currentUser?.id},
          }),
        },
        false
      )
      .then((res) => res)
  }

  export const updateAttendanceById = async (
    id: string,
    remark: string,
    accessToken: string,
    actionBy: {
      id: string
    }
  ) => {
    const {token, tenantId} = setupAxios()
    return await api
      .patch(
        `/attendence/update`,
        token,
        tenantId,
        {
          body: JSON.stringify({
            id,
            remark,
            accessToken,
            actionBy,
          }),
        },
        false
      )
      .then((res) => res)
  }

  export const handleClearFilterss = async (currentUser, inputField, tab) => {
    const {token, tenantId} = setupAxios()
    return await api
      .post(
        `/attendence?page=${1}&take=${10}`,
        token,
        tenantId,
        {
          body: JSON.stringify({
            tab: tab,
            id: currentUser?.id,
            startDate: inputField.startDate ? inputField.startDate + 'T00:00:00' : null,
            endDate: inputField.endDate ? inputField.endDate + 'T23:59:59' : null,
          }),
        },
        false
      )
      .then((res) => res)
  }

  // BULK UPLOAD COMMENTED OUT - Single record operations only
  /*
  export async function uploadAttendanceCSV(formField: {file: File | null}): Promise<any> {
    const {token, tenantId} = setupAxios()
    let formData = new FormData()
    formData.append('file', formField.file ?? '')

    return await api
      .post(
        `/${API.ATTENDENCE}/upload-csv`,
        token,
        tenantId,
        {
          body: formData,
        },
        true,
        true
      )
      .then((res) => res)
  }

  export async function uploadAttendenceFile(formField: {file: File | null}) {
    const {token, tenantId} = setupAxios()
    let formData = new FormData()
    formData.append('file', formField.file ?? '')

    return await api
      .post(
        `/${API.ATTENDENCE}/upload-csv2`,
        token,
        tenantId,
        {
          body: formData,
        },
        true,
        true
      )
      .then((res) => res)
  }
  */

  // Audit Logs API Functions
  export interface GetAttendanceLogsParams {
    action?: 'CREATE' | 'UPDATE' | 'DELETE'
    employeeCode?: string
    startDate?: string
    endDate?: string
    actionBy?: string
    page: number
    limit: number
  }

  export interface AttendanceLogRecord {
    id: string
    employeeCode: string
    action: 'CREATE' | 'UPDATE' | 'DELETE'
    actionBy: string
    actionByName?: string
    actionDate: string
    oldValues?: string
    newValues?: string
    details?: string
    recordDate?: string
    inTime?: string
    outTime?: string
  }

  export const getAttendanceLogs = async (params: GetAttendanceLogsParams): Promise<any> => {
    const {token, tenantId} = setupAxios()
    
    const queryParams = new URLSearchParams()
    queryParams.append('page', params.page.toString())
    queryParams.append('limit', params.limit.toString())
    
    if (params.action) queryParams.append('action', params.action)
    if (params.employeeCode) queryParams.append('employeeCode', params.employeeCode)
    if (params.startDate) queryParams.append('startDate', params.startDate)
    if (params.endDate) queryParams.append('endDate', params.endDate)
    if (params.actionBy) queryParams.append('actionBy', params.actionBy)

    return await api
      .get(
        `/${API.ATTENDENCE}/audit-logs?${queryParams.toString()}`,
        token,
        tenantId,
        false
      )
      .then((res) => res)
  }

  export const logAttendanceOperation = async (data: {
    employeeCode: string
    action: 'CREATE' | 'UPDATE' | 'DELETE'
    oldValues?: any
    newValues?: any
    details?: string
    recordDate?: string
    inTime?: string
    outTime?: string
  }): Promise<any> => {
    const {token, tenantId} = setupAxios()

    return await api
      .post(
        `/${API.ATTENDENCE}/audit-logs`,
        token,
        tenantId,
        {
          body: JSON.stringify(data)
        },
        false
      )
      .then((res) => res)
  }

  export const exportAttendanceLogs = async (params: {
    action?: 'CREATE' | 'UPDATE' | 'DELETE'
    employeeCode?: string
    startDate?: string
    endDate?: string
    actionBy?: string
  }): Promise<Blob> => {
    const {token, tenantId} = setupAxios()
    
    const queryParams = new URLSearchParams()
    if (params.action) queryParams.append('action', params.action)
    if (params.employeeCode) queryParams.append('employeeCode', params.employeeCode)
    if (params.startDate) queryParams.append('startDate', params.startDate)
    if (params.endDate) queryParams.append('endDate', params.endDate)
    if (params.actionBy) queryParams.append('actionBy', params.actionBy)

    const response = await fetch(
      `${API_BASE_URL}/${API.ATTENDENCE}/audit-logs/export?${queryParams.toString()}`,
      {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'X-TENANT-ID': tenantId,
        }
      }
    )

    if (!response.ok) {
      throw new Error('Failed to export logs')
    }

    return response.blob()
  }

  //1. Only Current Week Performnave Show
  // export async function getWeeklyPerformance(params?: {
  //   startDate?: string
  //   endDate?: string
  // }) {
  //   const { token, tenantId } = setupAxios();

  //   const queryParams = new URLSearchParams();

  //   if (params?.startDate) queryParams.append("startDate", params.startDate);
  //   if (params?.endDate) queryParams.append("endDate", params.endDate);

  //   return await api.get(
  //     `/dashboard/performance/weekly?${queryParams.toString()}`,
  //     token,
  //     tenantId,
  //     false
  //   );
  // }

  //2. Current Week Performnave & Previous Week performance Show
  export async function getWeeklyComparison() {
    const { token, tenantId } = setupAxios();

    return await api.get(
      `/dashboard/performance/weekly-comparison`,
      token,
      tenantId,
      false
    );
  }

export async function getMonthlyPerformance(params?: {
  startDate?: string
  endDate?: string
}) {
  const { token, tenantId } = setupAxios();

  const queryParams = new URLSearchParams();

  if (params?.startDate) queryParams.append("startDate", params.startDate);
  if (params?.endDate) queryParams.append("endDate", params.endDate);

  return await api.get(
    `/dashboard/performance/monthly?${queryParams.toString()}`,
    token,
    tenantId,
    false
  );
}

export async function getAttendanceTrend(params?: {
  startDate?: string
  endDate?: string
}) {
  const { token, tenantId } = setupAxios();

  const queryParams = new URLSearchParams();

  if (params?.startDate) queryParams.append("startDate", params.startDate);
  if (params?.endDate) queryParams.append("endDate", params.endDate);

  return await api.get(
    `/dashboard/performance/trend?${queryParams.toString()}`,
    token,
    tenantId,
    false
  );
}

//Dashboard Matrix Data
export async function getDashboardTodayAttendanceSummary() {
  const { token, tenantId } = setupAxios();
  const today = new Date().toISOString().split("T")[0];
  const queryParams = new URLSearchParams({
    page: "1",
    limit: "10",
    startDate: today,
    endDate: today,
    sortBy: "date",
    sort: "desc",
    preset: "all",
    status: "Present",
  });
  return await api.get(
    `/${API.ATTENDENCE}?${queryParams.toString()}`,
    token,
    tenantId,
    false
  );
}
